import React from "react";

export type Suggestion = { value: string; reason?: string };

interface Props {
  value: string;
  onChange: (v: string) => void;
  onBlur?: () => void;
  loading: boolean;
  ok: boolean | null;
  suggestions: Suggestion[];
  placeholder?: string;
}

const UsernameFieldCmp: React.FC<Props> = ({ value, onChange, onBlur, loading, ok, suggestions, placeholder }) => {
  return (
    <div className="grid grid-cols-12 gap-3 items-start">
      <div className="col-span-6">
        <label className="block text-sm font-medium text-gray-700">Username *</label>
        <input
          name="username"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          autoComplete="off"
          spellCheck={false}
          inputMode="text"
          className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-500"
          placeholder={placeholder || "Enter your username"}
        />
        <div className="mt-1 text-xs">
          {loading ? <span className="text-gray-500">Checking…</span> :
           ok === true ? <span className="text-green-600">Looks good ✓</span> :
           ok === false ? <span className="text-red-600">Taken</span> : null}
        </div>
      </div>

      <div className="col-span-6">
    <div className="text-xs text-gray-600 mb-1">Other available usernames:</div>
    <div className="flex flex-wrap gap-2">
          {suggestions.slice(0, 3).map((s) => (
            <button
              key={s.value}
              type="button"
      onClick={() => onChange(s.value)}
      className="rounded-full border border-gray-300 bg-white/70 px-3 py-1 text-xs shadow-sm hover:bg-white"
            >
              {s.value}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export const UsernameField = React.memo(UsernameFieldCmp);
